import { createSelector } from 'reselect';

import { SnapdocsClosingResource } from 'constants/snapdocsClosing';
import { extendObjWithUUID } from 'utils/uuid';

const selectSnapdocsClosingState = ({ snapdocsClosing }) => snapdocsClosing;

const withNotificationIds = qualityControl =>
  qualityControl && {
    ...qualityControl,
    notifications: (qualityControl.notifications ?? []).map(extendObjWithUUID),
  };

export const selectSnapdocsClosing = createSelector(
  selectSnapdocsClosingState,
  ({ applicationId, loadState, errorMessage, status, blocks, blockErrors }) => ({
    applicationId,
    loadState,
    errorMessage,
    status,
    blockErrors,
    appointment: blocks[SnapdocsClosingResource.APPOINTMENT] ?? null,
    borrowers: blocks[SnapdocsClosingResource.BORROWERS] ?? [],
    notaryOrder: blocks[SnapdocsClosingResource.NOTARY]?.order ?? null,
    qualityControl: withNotificationIds(blocks[SnapdocsClosingResource.QUALITY_CONTROL] ?? null),
    comments: blocks[SnapdocsClosingResource.COMMENTS] ?? [],
  }),
);
